export enum Alignments {
    LG = 'Lawful Good',
    NG = 'Neutral Good',
    CG = 'Chaotic Good',
    LN = 'Lawful Neutral',
    N = 'Neutral',
    CN = 'Chaotic Neutral',
    LE = 'Lawful Evil',
    NE = 'Neutral Evil',
    CE = 'Chaotic Evil',
}
